<script setup lang="ts">
import SlideUpDown from "vue-slide-up-down";
import Info from "~/components/icons/Info.vue";
import type { IRate } from "~/interfaces";
const locale = await getLocale("ui", "selected_amount");

const props = defineProps({
  value: { type: Number, required: true },
  model: { type: Object as () => IRate, required: false },
  koTaeg: { type: Number, required: false },
  koSecci: { type: String, required: false },
  customClass: { type: String, required: false },
  hasDetails: { type: Boolean, default: false }
});

const showDetails = ref(false)

const toggleDetails = () => {
  showDetails.value = !showDetails.value
}

const detailsText = computed(() => {
 if (!props.model) return null

  const useOneTextOrAnother = props.model.rate === 12;
  const text = useOneTextOrAnother 
    ? locale.amount_details_revolving 
    : locale.amount_details;

  const finalText = text
    .replace("%imp_finanz_text", props.model.imp_finanz ?? "")
    .replace("%tot_rata", props.model.imp_rata?.toString() ?? "")
    .replace("%rate", props.model?.rate.toString())
    .replace("%taeg", props.model?.taeg.toString());
    
  return finalText
})

const disclaimerText = computed(() => {
  if (!props.koTaeg) return null;
  let text = locale.amount_disclaimer
    .replace("%taeg", props.koTaeg)
  if(props.koSecci) 
    text += ` <a href="${props.koSecci}" class="underline" target="_blank">SECCI</a>`
  return text
})

</script>

<template>
<div class="bg-yellow ">
    
  <div class="selected-amount p-4 sm:px-6 lg:px-12 flex items-center justify-between lg:justify-start gap-4">
    <h1
      class="text-xl md:text-2xl font-semibold text-gray-700 leading-tight"
      :class="[customClass, hasDetails ? '' : 'w-full text-center sm:text-left']"
    >
      <span v-if="$slots.header">
        <slot name="header" />
      </span>
      <span v-else>
        {{ locale.title.replace("%d", formatNumber(value,1) ) }}
      </span>
    </h1>
    <button class="flex-shrink-0" type="button" v-if="hasDetails" @click="toggleDetails">
      <Info />
    </button>
  </div>
  <div v-if="hasDetails && model" class=" px-4 sm:px-6 lg:px-12">
    <SlideUpDown :active="showDetails" class="animate-collapse">
      <div class="pt-1" />
      <div class="bg-white px-5 pt-[11px] pb-4 lg:pb-3 rounded-[20px]">
        <div class="block lg:flex lg:flex-row-reverse lg:justify-end lg:items-baseline">
          <div class="flex justify-between items-baseline px-1 lg:border-l lg:border-black lg:pl-4">
            <p class="font-semibold text-lg lg:hidden">{{ model?.imp_finanz.toLocaleString("it-IT") }} €</p>
            <a :href="model?.secci_url ?? ''" class="underline leading-tight lg:text-sm" target="_blank">SECCI</a>
          </div>
          <div class="border-t border-gray-8 mt-3 px-1 lg:border-none lg:pr-4 lg:mt-0">
            <p v-html="detailsText" class="pt-3 lg:pt-0 lg:leading-tight lg:text-lg lg:mt-1" />
          </div>
        </div>
        <p v-if="disclaimerText" v-html="disclaimerText" class="text-xs px-1 lg:mt-2 pt-3 lg:pt-0" />
      </div>
      <div class="pt-4" />
    </SlideUpDown>
  </div>
</div>
</template>

<style scoped></style>
